import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ChatThanks from 'components/chat/Thanks';


export default connect(
  (state, ownProps) => {
    let { clientConfiguration} = state.chat.main;
    return {
      timeout: clientConfiguration.thanksTimeout,
      label: ownProps.label || clientConfiguration.thanksLabel,
      reload: clientConfiguration.thankAndReload,
    };
  },
  dispatch => ({ })
)(ChatThanks);



// WEBPACK FOOTER //
// ./containers/chat/Thanks.js